module.exports = __webpack_public_path__ + "img/soundPlaying.21cfb7e0.svg";